import React, { useMemo } from 'react';
import { Avatar } from 'antd';
import { getFileUrl, getInitials } from '../../utils';
import { generateAvatarColor } from '../../helper';

const UserAvatar = ({ user = {}, style = {}, size = 'default' }) => {
  const { first_name = '', last_name = '', id, profile_photo } = user;

  const fullName = useMemo(() => `${first_name} ${last_name}`.trim(), [first_name, last_name]);

  const profile = useMemo(() => {
    const photo = profile_photo ? JSON.parse(profile_photo) : null;
    return photo && id ? getFileUrl('users', id, photo) : null;
  }, [id, profile_photo]);

  const avatarStyles = useMemo(() => generateAvatarColor(fullName), [fullName]);

  return (
    <Avatar
      src={profile}
      style={{ backgroundColor: avatarStyles.bg, color: avatarStyles.text, borderColor: avatarStyles.bg, ...style }}
      size={size}
    >
      {getInitials(fullName)}
    </Avatar>
  );
};

export default UserAvatar;
